<template>
  <div id="error-page" class="registration-page">
    <div class="registration-page-container">
      <div class="message-box">
        <i class="message-icon error-ico" alt="에러 메시지 이미지"></i>
        <p class="message-text">
          죄송합니다.
        </p>
        <div class="section-separator" />

        <div class="group-horizontal">
          <p class="message-text">
            <span class="message-text-small">
              {{ message }}
            </span>
          </p>
        </div>
        <div class="section-separator" />
      </div>
      <!-- Default Error -->
      <!-- Access Error -->
      <!-- Auth Error -->
      <div v-if="type === 'default'" class="section">
        <div class="section-body">
          <div class="button-container input-wrap">
            <button
              type="button"
              class="normal-button input-width-small mw30"
              @click="close"
            >
              닫기
            </button>
            <span class="field-group-space"></span>
            <button type="button" class="secondary-button mw70">
              이전 페이지로 이동
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  data() {
    return {
      message: `현재 서비스 장애로 인하여 접속이 원할하지 않습니다.\n잠시 후에 다시 접속해 주시기 바랍니다.`,
      type: 'default'
    }
  },

  components: {},

  computed: {},

  created() {},

  beforeMount() {},

  mounted() {
    if (this.$route.params.message) {
      this.message = this.$route.params.message
    }

    if (this.$route.params.type) {
      this.type = this.$route.params.type
    }
  },

  methods: {
    /** 
     * Function    : close
     * Description : 닫기버튼 클릭 시 브라우져 닫기
     **/
    close() {
      self.close()
    }
  }
}
</script>

<style scoped>
.message-text-small {
  white-space: pre-line;
}
</style>
